<!--Select School-->
<div class="ua-Table">
	<!-- <select class="form-control" name="School" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="School">
        <option value="" style="display:none;"></option>
        <option *ngFor="let o of lstSchool" [ngValue]="o">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
    </select> -->

	<p-dropdown
		[disabled]="Processing == true"
		[options]="lstSchool"
		[(ngModel)]="School"
		(ngModelChange)="onSchoolChange($event)"
		optionLabel="SchoolFullName"
		[filter]="true"
		filterBy="SchoolFullName"
		[showClear]="false"
		placeholder="Select a school to assign roles to"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="School">
				<div class="form-control NoBorder" style="text-align: left">
					{{ School.SchoolFullName }}
				</div>
			</div>
		</ng-template>
		<ng-template let-SchoolItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ SchoolItem.SchoolFullName }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>
</div>

<!--Roles that are currently applied to the user-->
<div class="ua-Table TopMargin">
	<p-table
		#mydt
		[value]="lstRoles"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedRoles"
		dataKey="RoleID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--Role Name-->
				<th>
					<p-columnFilter type="text" field="RoleDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="UserLevelDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<th pSortableColumn="RoleDesc">User Role<p-sortIcon field="RoleDesc"></p-sortIcon></th>
				<th pSortableColumn="UserLevelDesc">User Level<p-sortIcon field="UserLevelDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-role>
			<tr [pSelectableRow]="role" [pTooltip]="role.ToolTip" tooltipPosition="bottom" showDelay="500" hideDelay="125">
				<td>
					<p-tableCheckbox [pSelectableRow]="role" [value]="role"></p-tableCheckbox>
				</td>
				<td
					*ngFor="let col of cols"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="role.DefinedByID == 1 ? 'Red' : 'Black'"
				>
					{{ role[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onCopyAll()">Copy to All Schools</button>
	<button [disabled]="Processing == true" class="btn btn-danger" style="margin-left: 5px" (click)="onRemove()">Remove</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
